import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { NgxMaskModule } from 'ngx-mask';
import { FormFieldModule } from '../form-field/form-field.module';
import { InputComponent } from './components/input/input.component';
import { ToFixedPipe } from './components/input/to-fixed.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormlyModule,
    ReactiveFormsModule,
    FormFieldModule,
    NgxMaskModule.forChild(),
  ],
  declarations: [InputComponent, ToFixedPipe],
  providers: [ToFixedPipe],
  exports: [InputComponent, FormFieldModule],
})
export class InputModule {}
